import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useSite } from "../../lib/auth";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import { InquiryForm } from "./Quote";

export const PageHero = ({ eyebrow, title, sub, img }) => (
  <section className="relative isolate overflow-hidden bg-[#0a2f4d]">
    {img && <img src={img} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-40" />}
    <div className="container-x py-20 text-white"><p className="eyebrow">{eyebrow}</p><h1 className="mt-3 max-w-3xl text-4xl font-semibold sm:text-5xl lg:text-6xl">{title}</h1>{sub && <p className="mt-4 max-w-2xl text-slate-200">{sub}</p>}</div>
  </section>
);

export function About() {
  const { site } = useSite();
  return (
    <div>
      <PageHero eyebrow="About us" title="Journeys built around people." img="/images/travelers.jpg" />
      <section className="container-x grid gap-12 py-16 lg:grid-cols-3">
        <div className="lg:col-span-2 space-y-5 text-slate-700 leading-relaxed" data-testid="about-text"><p className="text-lg">{site.about}</p>
          <p>Our team plans hosted group departures for organizations, designs private custom vacations, and books ocean and river cruises — with one travel advocate supporting you from inquiry to homecoming.</p></div>
        <div className="card p-6"><h3 className="text-2xl font-semibold">Ready to plan?</h3><p className="mt-2 text-sm text-slate-600">Tell us about your group or your dream trip.</p><Link to="/quote" className="btn-accent mt-5 w-full">Request a Quote</Link></div>
      </section>
    </div>
  );
}

export function Faq() {
  const { site } = useSite();
  return (
    <div>
      <PageHero eyebrow="Help" title="Frequently asked questions" />
      <section className="container-x max-w-3xl py-16">
        <Accordion type="multiple" data-testid="faq-accordion">
          {(site.faqs || []).map((f, i) => (
            <AccordionItem key={i} value={`f${i}`}><AccordionTrigger className="text-left text-base" data-testid={`faq-item-${i}`}>{f.q}</AccordionTrigger><AccordionContent className="text-slate-600">{f.a}</AccordionContent></AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}

export function Contact() {
  const { site } = useSite();
  const c = site.contact || {};
  return (
    <div>
      <PageHero eyebrow="Contact" title="We'd love to hear from you." />
      <section className="container-x grid gap-10 py-16 lg:grid-cols-3">
        <div className="space-y-5" data-testid="contact-details">
          {[[Phone, c.phone], [Mail, c.email], [MapPin, c.address], [Clock, c.hours]].map(([I, v], i) => v && <div key={i} className="flex gap-3"><I className="h-5 w-5" style={{ color: "var(--brand-accent)" }} /><span>{v}</span></div>)}
        </div>
        <div className="card p-6 lg:col-span-2"><InquiryForm kind="contact" /></div>
      </section>
    </div>
  );
}
